"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LaserBrushShader = void 0;
/**
 * Copyright (c) 2024 BrightSpike
 * All rights reserved.
 *
 * This source code is unlicensed.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 *
 * For detailed license information, please contact Brightspike at (info@brightspike.io).
 * @author Austin Weidler
 */
const BrushShader_1 = require("./BrushShader");
const laser_frag_1 = __importDefault(require("./glsl/laser.frag"));
class LaserBrushShader extends BrushShader_1.BrushShader {
    constructor() {
        super(laser_frag_1.default, {});
        this.ticker.speed = 1 / 80;
    }
}
exports.LaserBrushShader = LaserBrushShader;
